import { styled } from '@mui/material';

type PropsStyle = {
  position_x?: string | number;
  position_y?: string | number;
};
const color = '#464646';
export const CircleMenu = styled(
  'div',
  {}
)<PropsStyle>(({ position_x, position_y }) => {
  return {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '40px',
    height: '40px',
    backgroundColor: 'white',
    borderRadius: '20px',
    border: `1px solid ${color}`,
    position: 'absolute',
    top: position_x || 0,
    left: position_y || 0,
    opacity: 0,
    transition: 'transform 500ms, opacity 300ms',
  };
});
